export default __webpack_public_path__ + "static/media/Modelo 7.85616382.png";